import React from 'react';
import css from './SeoPage.module.css';

const Description = ({ title, description, rawDescription, ...props }) => {
  const content = rawDescription || description;

  if (!title && !content) {
    return null;
  }

  return (
    <div className={css.descriptionSection}>
      {title && (
        <h2 className={css.sectionTitle}>
          {' '}
          {/* ✅ h2 for section titles */}
          {title}
        </h2>
      )}
      {content && (
        <div className={css.descriptionContent}>
          {typeof content === 'string' ? <p>{content}</p> : content}
        </div>
      )}
    </div>
  );
};

export default Description;
